module.exports = __webpack_public_path__ + "img/Prodoctfour-top.115c20a1.png";